import { useQuery } from '@tanstack/react-query';
import moment from 'moment-timezone';
import { getTimezone } from '@mgm/common/utils';
import { useAppDispatch, useAppSelector } from '../useAppStore';
import { getAuthenticateUser } from '../../store/authenticate/selectors';
import { DashboardController } from '../../services/dashboard.api';
import { TGetDashboardDataRes } from '../../types/responses';
import { QUERY_KEYS } from '../../utils/enums';
import { dashboardActions } from '../../store/dashboard/slice';
import { useError } from '../useCommon';

type TDashboardOptions = {
  dates?: {
    fromDate: string,
    toDate: string
  },
};

export function useGetDashboardDailyStateAPI(options?: TDashboardOptions) {
  const { personnel } = useAppSelector(getAuthenticateUser);
  const dispatch = useAppDispatch();
  const { handleReqError } = useError();
  const timezone = getTimezone();

  return useQuery(
    [QUERY_KEYS.DASHBOARD.DAILY],
    async () => {
      const data = {
        shopName: personnel?.shopName || '',
        timezone,
        from: options?.dates?.fromDate || moment.tz(timezone).startOf('day').format(),
        to: options?.dates?.toDate || moment.tz(timezone).endOf('day').format(),
      };

      const rsp = await DashboardController().getDashboardDailyState<TGetDashboardDataRes>(data);

      if (rsp?.success && 'dashboardData' in rsp) {
        dispatch(dashboardActions.setDashboardData(rsp?.dashboardData || {}));
      } if (rsp?.error || rsp.error?.response?.status) {
        handleReqError(rsp.error);
      } if ('msg' in rsp) {
        console.error(`ERROR! get dashboard data failed! ${rsp.msg}`);
      }

      return rsp;
    },
    {
      staleTime: 3 * (60 * 1000),
      suspense: false,
      refetchOnWindowFocus: false,
      enabled: true,
      refetchOnReconnect: false,
    },
  );
}
